import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { Link } from 'react-router-dom';
import Date from '../../Atoms/Date';
import Title from '../../Atoms/Title';

import { IListItemProps } from './ListItem.definitions';

/** CSS import */
import Styles from './ListItem.module.scss';

const ListItem: React.FC<IListItemProps> = ({
  title,
  date,
  image,
  link,
  isLastItem,
}: IListItemProps) => {
  if (isLastItem) {
    return (
      <Link to={link}>
        <div className={Styles['wrapper-last']}>
          <p className={Styles['view-all']}>View all</p>
          <p className={Styles['section']}>Luxury</p>
        </div>
      </Link>
    );
  }
  return (
    <Link to={link}>
      <div className={Styles['wrapper']}>
        <KickImage src={image} className={Styles['image']} />
        <div>
          <Title text={title || ''} />
          <Date text={date || ''} />
        </div>
      </div>
    </Link>
  );
};

export default ListItem;
